import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../../Component/Layouts/App/Candidates/StudentApp/Icon';
import { PageHeader, SectionTitle } from '../../../../Component/Layouts/App/Candidates/StudentApp/StudentUi';
import { useStudent } from '../../../../Component/Layouts/App/Candidates/StudentApp/StudentContext';
import { STUDENT_BASE, profileStats, skills } from '../../../../Component/Layouts/App/Candidates/StudentApp/studentData';

const StudentProfile = () => {
  const navigate = useNavigate();
  const { xp, toggleTheme, showToast } = useStudent();

  return (
    <>
      <PageHeader
        title="My Profile"
        right={(
          <button type="button" className="sa-ib" aria-label="Theme" onClick={toggleTheme}>
            <Icon name="zap" />
          </button>
        )}
      />
      <div className="sa-row">
        <div className="sa-av" style={{ width: 72, height: 72, fontSize: 24 }}>AS</div>
        <div className="sa-sp">
          <div className="sa-b" style={{ fontSize: 19 }}>Aditi Sharma</div>
          <div className="sa-mut" style={{ marginBottom: 8 }}>Level 7 · {xp.toLocaleString()} XP</div>
          <button type="button" className="sa-btn" onClick={() => showToast('Edit profile')}>Edit Profile</button>
        </div>
      </div>

      <div className="sa-card sa-stat">
        {profileStats.map((stat) => (
          <div key={stat.label}>
            <Icon name={stat.icon} />
            <b>{stat.value}</b>
            <span className="sa-mut">{stat.label}</span>
          </div>
        ))}
      </div>

      <SectionTitle title="Skills" action="+ Add" onAction={() => showToast('Add a skill')} />
      <div>
        {skills.map((skill) => <span className="sa-tag lg" key={skill}>{skill}</span>)}
      </div>

      <SectionTitle title="About me" />
      <div className="sa-mut sa-about">
        Passionate learner, creative thinker and team player. Excited about building a positive impact through technology and community.
      </div>

      <SectionTitle title="My achievements" action="See all" onAction={() => navigate(`${STUDENT_BASE}/achievements`)} />
      <div className="sa-two">
        <button type="button" className="sa-shot short" aria-label="Hackathon achievement" onClick={() => navigate(`${STUDENT_BASE}/achievement`)}>
          <Icon name="trophy" className="xl" />
        </button>
        <button type="button" className="sa-shot short alt" aria-label="Certificate" onClick={() => navigate(`${STUDENT_BASE}/achievement`)}>
          <Icon name="file" className="xl" />
        </button>
      </div>
    </>
  );
};

export default StudentProfile;
